// اعتبارسنجی موبایل و کد ملی ایران — معادل IranianMobile و IranianNationalId سرور (BR-PAT-002، BR-PAT-013).
import { keepDigitsOnly } from './digits';

/** نرمال‌سازی موبایل به شکل ملی 09xxxxxxxxx؛ نامعتبر ← undefined. */
export function normalizeMobile(value: string | null | undefined): string | undefined {
  let digits = keepDigitsOnly(value);
  if (digits.length === 0) {
    return undefined;
  }
  if (digits.startsWith('0098')) {
    digits = digits.slice(4);
  } else if (digits.length > 11 && digits.startsWith('98')) {
    digits = digits.slice(2);
  }
  if (digits.length === 10 && digits[0] === '9') {
    digits = `0${digits}`;
  }
  return /^09\d{9}$/.test(digits) ? digits : undefined;
}

export function isValidMobile(value: string | null | undefined): boolean {
  return normalizeMobile(value) !== undefined;
}

/** نرمال‌سازی کد ملی به ۱۰ رقم (ورودی ۸ و ۹ رقمی با صفر ابتدایی). */
export function normalizeNationalId(value: string | null | undefined): string | undefined {
  const digits = keepDigitsOnly(value);
  if (digits.length < 8 || digits.length > 10) {
    return undefined;
  }
  return digits.padStart(10, '0');
}

export function isValidNationalId(value: string | null | undefined): boolean {
  const normalized = normalizeNationalId(value);
  if (!normalized || /^(\d)\1{9}$/.test(normalized)) {
    return false;
  }
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += Number(normalized[i]) * (10 - i);
  }
  const remainder = sum % 11;
  const check = Number(normalized[9]);
  return remainder < 2 ? check === remainder : check === 11 - remainder;
}

const LEGAL_ID_COEFFICIENTS = [29, 27, 23, 19, 17, 29, 27, 23, 19, 17];

/** شناسه ملی اشخاص حقوقی (۱۱ رقم با رقم کنترل) — معادل LegalEntityId سرور (AP-PLT-01، C-AGENT-166). */
export function isValidLegalEntityId(value: string | null | undefined): boolean {
  const digits = keepDigitsOnly(value);
  if (!/^\d{11}$/.test(digits) || /^(\d)\1{10}$/.test(digits)) {
    return false;
  }
  const bonus = Number(digits[9]) + 2;
  let sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += (Number(digits[i]) + bonus) * (LEGAL_ID_COEFFICIENTS[i] ?? 0);
  }
  const remainder = sum % 11;
  return (remainder === 10 ? 0 : remainder) === Number(digits[10]);
}
